import PropTypes from 'prop-types';
import GenericSection from '../GenericSection/GenericSection';
import ContactSection from './ContactSection';

export default function ContactSectionWrapper(props) {
  return (
    <div data-test="ContactSectionWrapper">
      <GenericSection
        step={props.step}
        isStepActive={props.isStepActive}
        id="ContactSection__heading"
        headerKey="checkout.contact.section.heading.text"
      >
        <ContactSection isStepActive={props.isStepActive} />
      </GenericSection>
    </div>
  );
}

ContactSectionWrapper.propTypes = ({
  step: PropTypes.number.isRequired,
  isStepActive: PropTypes.bool.isRequired,
});
